import { PartialTranslation } from '../translations';

export const ar: PartialTranslation = {
  newChat: 'محادثة جديدة',
  search: 'بحث',
  user: 'المستخدم',
  settings: 'الإعدادات',
  language: 'اللغة',
  getHelp: 'احصل على مساعدة',
  viewAllPlans: 'عرض جميع الخطط',
  learnMore: 'اعرف المزيد',
  logOut: 'تسجيل الخروج',
  chooseLanguage: 'اختر اللغة',
  chooseYourPreferredLanguage: 'اختر لغتك المفضلة',
  searchLanguages: 'البحث في اللغات...',
  autoDetect: 'الكشف التلقائي',
  noLanguagesFound: 'لم يتم العثور على لغات',
  askAnything: 'اسأل أي شيء',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'شخصي',
  freePlan: 'خطة مجانية',
  current: 'الحالي',
  close: 'إغلاق',
  archive: 'أرشيف',
  delete: 'حذف',
  confirmDelete: 'هل أنت متأكد من أنك تريد حذف هذه المحادثة؟',
  confirmArchive: 'هل أنت متأكد من أنك تريد أرشفة هذه المحادثة؟',
  deleteCannotUndo: 'لا يمكن التراجع عن هذا الإجراء.',
  archiveCanFind: 'يمكنك العثور عليها في قائمة الأرشيف بعد الأرشفة.',

  // 归档标签页
  chats: 'المحادثات',
  archived: 'مؤرشف',
  restore: 'استعادة',
  noArchivedChats: 'لا توجد محادثات مؤرشفة',
  backToChats: 'العودة إلى المحادثات',

  // 资源面板
  resources: 'الموارد',
  addResource: 'إضافة مورد',
  deleteResource: 'حذف المورد',
  noMatchingResourcesFound: 'لم يتم العثور على موارد مطابقة',
  noResourcesAvailable: 'لا توجد موارد متاحة',
  hideResources: 'إخفاء الموارد',
  showResources: 'إظهار الموارد',

  // 聊天输入框
  typeMessage: 'اكتب رسالة...',
  thinkingOptions: 'خيارات التفكير',
  deleteFile: 'حذف الملف',
  clearSelection: 'مسح التحديد',
  addAttachment: 'إضافة مرفق',
  sendMessage: 'إرسال الرسالة',

  // 思考模式选项
  deepInsight: 'بصيرة عميقة · تحليل سطحي',
  deepInsightDesc: 'فهم سريع للنقاط الرئيسية',
  deepExploration: 'استكشاف عميق · تحليل شامل',
  deepExplorationDesc: 'بحث عميق متعدد الأبعاد',
  deepDeconstruction: 'تفكيك عميق · حجة منهجية',
  deepDeconstructionDesc: 'تحليل تدريجي طبقة بطبقة',

  // 写作模式选项
  contractReview: 'مراجعة العقد · تحديد المخاطر',
  contractReviewDesc: 'تحليل البنود وفحص الامتثال',
  textPolish: 'تنميق النص · التعبير المهني',
  textPolishDesc: 'تحسين اللغة وضبط الهيكل',
  legalDocuments: 'الوثائق القانونية · صياغة معيارية',
  legalDocumentsDesc: 'كتابة مهنية للوثائق القانونية',

  // 认证和隐私翻译
  login: 'تسجيل الدخول',
  register: 'إنشاء حساب',
  welcomeBack: 'مرحباً بك في LawHelper',
  loginSubtitle: 'مساعدك الذكي للبحث القانوني',
  continueWithGoogle: 'المتابعة مع Google',
  continueWithMicrosoft: 'المتابعة مع Microsoft',
  continueWithWeChat: 'المتابعة مع WeChat',
  orContinueWith: 'أو المتابعة مع',
  emailTab: 'البريد الإلكتروني',
  phoneTab: 'الهاتف',
  emailPlaceholder: 'أدخل بريدك الإلكتروني',
  phonePlaceholder: 'أدخل رقم الهاتف',
  codePlaceholder: 'أدخل الرمز المكون من 6 أرقام',
  sending: 'جارٍ الإرسال...',
  verifying: 'جارٍ التحقق...',
  verify: 'تحقق',
  sendMagicLink: 'إرسال رابط سحري',
  getVerificationCode: 'الحصول على الرمز',
  resendCode: 'إعادة إرسال الرمز',
  resendIn: 'إعادة الإرسال خلال',
  magicLinkSent: 'تم إرسال الرابط السحري إلى بريدك',
  magicLinkHint: 'سنرسل رابطاً آمناً إلى بريدك الإلكتروني',
  otpSent: 'تم إرسال رمز التحقق',
  agreeToTerms: 'بالمتابعة، أنت توافق على',
  privacyPolicy: 'سياسة الخصوصية',
  termsOfService: 'شروط الخدمة',
  and: 'و',
  privacyTitle: 'خصوصيتك مهمة',
  privacyIntro: 'نستخدم ملفات تعريف الارتباط والتقنيات المماثلة لتوفير أفضل تجربة لك.',
  essentialCookies: 'ملفات تعريف الارتباط الأساسية',
  essentialDesc: 'مطلوبة لعمل الموقع',
  analyticsCookies: 'ملفات تعريف الارتباط التحليلية',
  analyticsDesc: 'تساعدنا في تحسين خدمتنا',
  marketingCookies: 'ملفات تعريف الارتباط التسويقية',
  marketingDesc: 'تستخدم للمحتوى المخصص',
  acceptAll: 'قبول الكل',
  essentialOnly: 'الأساسية فقط',
  customize: 'تخصيص',
  savePreferences: 'حفظ التفضيلات',
  back: 'رجوع',
  readPrivacyPolicy: 'اقرأ سياسة الخصوصية',
  cookiePolicy: 'سياسة ملفات تعريف الارتباط',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'مراجعة AI',
  aiDraft: 'مسودة AI',
  smartAssistant: 'قالب',

  // 知识库搜索
  enableKnowledgeSearch: 'تفعيل البحث',
  knowledgeSearchDesc: 'البحث في مستنداتك أولاً',
  clickToDisable: 'تعطيل',
  clickToEnable: 'تفعيل',

  // Landing page translations
  tagline: 'ذكاء قانوني بالذكاء الاصطناعي',
  heroTitle1: 'Legal AI',
  heroTitle2: 'مبسّط.',
  jurisdictionsLabel: 'الولايات القضائية',
  accuracyLabel: 'الدقة',
  fasterLabel: 'أسرع',
  availableLabel: 'متاح',
  platformCapabilities: 'القدرات',
  testimonialQuote: '"LawHelper غيّر عملنا."',
  testimonialAuthor: 'متخصص',
  testimonialPosition: 'شريك',
  viewPricing: 'الأسعار',
  footerPricing: 'الأسعار',
  footerPrivacy: 'الخصوصية',
  footerTerms: 'الشروط',
  footerContact: 'اتصل',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  closeResourcesPanel: 'إغلاق لوحة الموارد',
  uploading: 'جارٍ رفع %{fileName}...',
  processing: 'جارٍ معالجة %{fileName}...',
  uploadSuccess: '✓ تم رفع %{fileName}',
  uploadError: '✗ فشل الرفع: %{error}',
  quickAnswer: 'إجابة سريعة',
  quickAnswerDesc: 'إجابة سريعة على الأسئلة البسيطة',
  cancelRequest: 'إلغاء',
  library: 'المكتبة',
  filterAll: 'الكل',
  filterChat: 'المحادثات',
  filterReview: 'المراجعة',
  filterDraft: 'مسودة',
  filterTemplate: 'قالب',
  filterForm: 'نموذج',
  thinking: 'جارٍ التفكير...',
  thinkingProcess: 'عملية التفكير',
  analyzingLegalLogic: 'تحليل المنطق القانوني...',
  lawhelperThinking: 'Lawhelper يفكر...',
  serviceError: 'خطأ في الخدمة',
  uploaded: 'تم الرفع',
  settingsGeneral: 'عام',
  settingsNotifications: 'الإشعارات',
  settingsAppearance: 'المظهر',
  settingsProfile: 'الملف الشخصي',
  settingsResponseNotifications: 'إشعارات الرد',
  settingsResponseNotificationsDesc: 'إشعار عند اكتمال رد الذكاء الاصطناعي',
  settingsColorMode: 'وضع الألوان',
  settingsLight: 'فاتح',
  settingsDark: 'داكن',
  settingsSystem: 'النظام',
  about: 'حول',
  reviewTitle: 'مراجعة المستند',
  exitReview: 'الخروج من المراجعة',
  uploadPrompt: 'ارفع ملف PDF للمراجعة',
  uploadButton: 'اختر ملفاً',
  startChatConfig: 'اكتب "راجع هذا المستند"',
  reviewPlaceholder: 'اكتب رسالة...',
  analyzing: 'جارٍ المراجعة...',
  reviewComplete: 'اكتملت المراجعة',
  issuesFound: 'تم العثور على %{count} مشكلة',
  draftTitle: 'صياغة مستند قانوني',
  draftPlaceholder: 'حرر هنا أو اطلب من الذكاء الاصطناعي...',
  analyzingTemplate: 'تحليل القالب %{name}...',
  templateAnalyzed: '✅ تم تحليل القالب %{name}!',
  templateAnalysisPrompt: 'تحليل البنود الرئيسية',
  parsingFailed: '⚠️ فشل تحليل الملف.',
  generating: 'جارٍ التوليد...',
  generatedSuccess: '✅ تم إنشاء المستند!',
  drafterWelcome: 'مرحباً بك في مساعد المستندات الذكي',
  drafterYouCan: 'يمكنك:',
  drafterUploadTemplate: 'رفع قالب للتحليل',
  drafterDescribeNeeds: 'وصف متطلبات المستند',
  drafterLetAiHelp: 'الذكاء الاصطناعي يساعد في صياغة العقود والاتفاقيات',
  drafterExamples: 'أمثلة:',
  drafterExampleRental: '"صِغ عقد إيجار"',
  drafterExampleLabor: '"املأ عقد العمل وفق القالب"',
  drafterInputPlaceholder: 'صف احتياجاتك...',
  drafterThinking: 'جارٍ التفكير...',
  drafterHistoryTitle: 'السجل',
  drafterNoHistory: 'لا يوجد سجل',
  drafterNewChat: 'محادثة جديدة',
  drafterHistory: 'السجل',
  drafterRemoveAttachment: 'إزالة المرفق',
  drafterLineHeight: 'ارتفاع السطر',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'تصدير كـ Word (.docx)',
  drafterExportPdf: 'تصدير كـ PDF',
  drafterSave: 'حفظ المستند',
  drafterDownload: 'تنزيل المستند',
  drafterUndo: 'تراجع',
  drafterRedo: 'إعادة',
  drafterBold: 'غامق',
  drafterItalic: 'مائل',
  drafterStrike: 'يتوسطه خط',
  drafterUnderline: 'تحته خط',
  drafterHighlight: 'تمييز',
  drafterLink: 'إدراج رابط',
  drafterAlignLeft: 'محاذاة لليسار',
  drafterAlignCenter: 'توسيط',
  drafterAlignRight: 'محاذاة لليمين',
  drafterAlignJustify: 'ضبط',
  drafterList: 'قائمة',
  drafterBulletList: 'قائمة نقطية',
  drafterOrderedList: 'قائمة مرقمة',
  drafterTaskList: 'قائمة مهام',
  drafterOpenResource: 'فتح لوحة الموارد',
  drafterStopGeneration: 'إيقاف التوليد',
  drafterAgentMode: 'وضع الوكيل مفعل',
  drafterAgentModeOn: 'وضع الوكيل مفعل',
  drafterAgentModeOff: 'الوضع العادي',
  drafterUploadAttachment: 'رفع مرفق',
  drafterExit: 'خروج',
  drafterConfirm: 'تأكيد',
  drafterOpenLink: 'فتح الرابط',
  drafterDeleteLink: 'حذف الرابط',
  drafterQuote: 'اقتباس',
  workflowTitle: 'سير عمل الذكاء الاصطناعي',
  workflowRunning: 'قيد التنفيذ...',
  workflowReady: 'جاهز',
  workflowCompleted: 'مكتمل',
  workflowStartFailed: 'فشل بدء سير العمل',
  workflowExecutionFailed: 'فشل تنفيذ سير العمل',
  workflowInterrupted: 'تم إيقاف سير العمل',
  workflowProcessing: 'جارٍ المعالجة...',
  workflowStepsCompleted: 'خطوات مكتملة',
  workflowStepsTotal: 'سير العمل مكتمل (%{count} خطوة)',
  acceptChanges: 'قبول التغييرات',
  rejectChanges: 'رفض التغييرات',
  changesAccepted: 'تم قبول التغييرات',
  changesRejected: 'تم رفض التغييرات',
  stopWorkflow: 'إيقاف',
  restartWorkflow: 'إعادة تشغيل',
  startDrafting: 'بدء الصياغة',
  interrupt: 'إيقاف',
  documentSubject: 'موضوع المستند *',
  documentType: 'نوع المستند',
  jurisdiction: 'الاختصاص القضائي',
  specialRequirements: 'متطلبات خاصة (اختياري)',
  clickStartDrafting: 'انقر "بدء الصياغة"',
  docTypeContract: 'عقد',
  docTypeAgreement: 'اتفاقية',
  docTypeNotice: 'إشعار',
  docTypeLetter: 'خطاب',
  docTypePetition: 'عريضة',
  docTypeWill: 'وصية',
  docTypePowerOfAttorney: 'توكيل',
  countryChina: 'الصين',
  countryUSA: 'الولايات المتحدة',
  countryGermany: 'ألمانيا',
  countryJapan: 'اليابان',
  countryFrance: 'فرنسا',
  countryUK: 'المملكة المتحدة',
  citationVerified: 'تم التحقق',
  citationUnverified: 'لم يتم التحقق',
  imageLoadFailed: 'فشل تحميل الصورة',
  smartDocTitle: 'مساعد المستندات الذكي',
  smartDocChatTitle: 'مساعد المستندات بالذكاء الاصطناعي',
  smartDocDropPrompt: 'أسقط ملف PDF هنا',
  smartDocSelectFile: 'اختر ملفاً',
  smartDocOr: 'أو',
  smartDocWelcomeTitle: 'مرحباً بك في مساعد المستندات',
  smartDocWelcomeYouCan: 'يمكنك:',
  smartDocUploadForAI: 'رفع قالب للتحليل',
  smartDocDescribeDoc: 'وصف المتطلبات',
  smartDocLetAIDraft: 'الذكاء الاصطناعي يساعد في العقود',
  smartDocExamples: 'أمثلة:',
  smartDocExampleRental: '"صِغ عقد إيجار"',
  smartDocExampleLabor: '"املأ عقد العمل"',
  smartDocInputPlaceholder: 'صف احتياجاتك...',
  smartDocRemoveAttachment: 'إزالة المرفق',
  smartDocOpenResources: 'فتح الموارد',
  smartDocExit: 'خروج',
  reviewStartFailed: 'فشل بدء المراجعة',
  reviewFailed: 'فشلت المراجعة',
  reviewFoundIssues: 'اكتملت المراجعة، %{count} مشكلة.',
  cannotReadStream: 'تعذر قراءة تدفق الاستجابة',
  parseEventFailed: 'فشل تحليل الحدث',
  errorPrefix: 'خطأ',
  unknownError: 'خطأ غير معروف',
  file: 'ملف',
  loading: 'جارٍ التحميل...',
  localFolders: 'المجلدات المحلية',
  selectLocalFolder: 'اختر مجلداً محلياً',
  reselectFolder: 'تغيير المجلد',
  addToContext: 'إضافة إلى المحادثة',
  saveFile: 'حفظ',
  renameFile: 'إعادة تسمية',
  fileSaved: 'تم حفظ الملف',
  fileRenamed: 'تم تسمية الملف إلى %{name}',
  browserNotSupported: 'متصفحك لا يدعم الوصول للمجلدات المحلية',
  noFolderSelected: 'اختر مجلداً محلياً',
  scanningFolder: 'فحص المجلد...',
  selectFileToPreview: 'اختر ملفاً للمعاينة',
  aiAnalyze: 'تحليل الذكاء الاصطناعي',
};
